import { render, staticRenderFns } from "./x-multiple-tab-list-page.vue?vue&type=template&id=f640870c"
import script from "./x-multiple-tab-list-page.vue?vue&type=script&lang=js"
export * from "./x-multiple-tab-list-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports